import { Grid } from '@mui/material';
import { StatsCard } from './StatsCard';
import { ReactNode } from 'react';

export interface StatItem {
  title: string;
  value: string | number;
  icon: ReactNode;
  tooltip?: string;
}

interface StatsGridProps {
  stats: StatItem[];
}

export function StatsGrid({ stats }: StatsGridProps) {
  return (
    <Grid container spacing={{ xs: 2, md: 3 }} mb={{ xs: 3, md: 4 }}>
      {stats.map((stat) => (
        <Grid item xs={12} sm={6} md={3} key={stat.title}>
          <StatsCard
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            tooltip={stat.tooltip}
          />
        </Grid>
      ))}
    </Grid>
  );
}
